export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9665.879ff79a.jpg";